export const obtenerStringLocal = ({key}) => {

    return window.localStorage.getItem(key)


}